module.exports = __webpack_public_path__ + "img/product_47.3b29645.webp";